export enum ComponentId {
  APPLICANT_DRIVER_NAME = "name",
  APPLICANT_DRIVER_SURNAME = "surname",
  APPLICANT_DRIVER_PHONE = "phone",
  APPLICANT_DRIVER_EMAIL = "email",
  APPLICANT_DRIVER_PESEL = "pesel",
  APPLICANT_DRIVER_DRIVING_LICENSE = "drivingLicense",
  APPLICANT_DRIVER_LACK_OF_PESEL = "lackOfPesel",
  APPLICANT_DRIVER_STREET = "street",
  APPLICANT_DRIVER_STREET_2 = "street2",
  APPLICANT_DRIVER_ZIP_CODE = "zipCode",
  APPLICANT_DRIVER_CITY = "city",
  APPLICANT_DRIVER_COUNTRY = "country",
}
